import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { getItemClassificationTypeName, ItemClassificationType } from '@models/items.models';
import { TranslatePipe } from '@ngx-translate/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-item-classification-type-column',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './item-classification-type-column.component.html',
  styleUrl: './item-classification-type-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemClassificationTypeColumnComponent implements AgRendererComponent {
  readonly classificationType = signal<string>('');

  agInit(params: ICellRendererParams): void {
    this.classificationType.set(getItemClassificationTypeName(params.value as ItemClassificationType));
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
